<template>
  <div class="h-100 text-center pt-5 mt-5">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100px"
      height="100px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      class="lds-rolling"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#2167f5"
        stroke-width="10"
        r="30"
        stroke-dasharray="141.37166941154067 49.12388980384689"
        transform="rotate(102 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          calcMode="linear"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          dur="1s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
    <h6>{{ message ? message : 'Processing request...' }}</h6>
  </div>
</template>

<script>
export default {
  name: 'Loading.vue',
  props: {
    message: String
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Loading.vue